import { FormControl } from '@angular/forms';

export function validateQuantityRange(c: FormControl) {
  const err = {
    rangeError: {
      given: c.value,
      max: 99,
      min: 0
    }
  };
  return c.value > 99 || c.value < 0 ? err : null;
}
